import { useQuery } from '@tanstack/react-query';
import { getDealData as getDealDataRequest } from '@dealstack/frontend/shared/dataExchange/services/project.service';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';

export const useGetDealData = () => {
	return useQuery({
		queryKey: [API_PATHS.DEAL_DATA_GET],

		queryFn: async () => {
			return getDealDataRequest();
		},
	});
};
